<template>
  <div class="account-pages my-5 pt-5">
    <b-container>
      <b-row>
        <b-col lg="12">
          <div class="text-center mb-5">
            <h1 class="display-2 font-weight-medium">4<i class="bx bx-buoy bx-spin text-primary display-3"></i>4</h1>
            <h4 class="text-uppercase">Страница не найдена</h4>
            <div class="mt-5 text-center">
              <router-link tag="a" class="btn btn-primary" to="/">Вернуться на главную</router-link>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col md="8" xl="6">
          <div>
            <img src="@/assets/images/error-img.png" alt class="img-fluid" />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: '404'
};
</script>
